import { colors } from "./config";

export const Tag = {
  variants: {
    solid: {
      container: {
        bg: colors.brand.primary.base,
      }
    }
  },
  sizes: {
    md: {
      container: {
        borderRadius: '5px',
      }
    }
  }
};
